import { render, staticRenderFns } from "./BindsDialogTitle.vue?vue&type=template&id=5f14f262&"
import script from "./BindsDialogTitle.vue?vue&type=script&lang=js&"
export * from "./BindsDialogTitle.vue?vue&type=script&lang=js&"
import style0 from "./BindsDialogTitle.vue?vue&type=style&index=0&id=5f14f262&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports